import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import {SubscriptionsService} from '../../../_services/subscriptions.service';
import {LotteriesService} from '../../../lotteries.service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent implements OnInit {
  visibleCookies: boolean;
  languageChange: any;
  showLang: any;
  isMobile: any;
  cartSubscription: Subscription;
  isCart: any;
  constructor(private subscriptionsService: SubscriptionsService, private renderer: Renderer2, private el: ElementRef, public lotteryService: LotteriesService,
  private router: Router) {
      this.languageChange = this.subscriptionsService.getLanguage().subscribe( lang => {
          this.showLang =  lang;
      });
      this.cartSubscription = this.subscriptionsService.getIsCart().subscribe(isCart => {
          this.isCart = isCart;
      });
  }

  ngOnInit() {
      if ( this.router.url === '/en/cart' || this.router.url === '/de/cart') {
          this.isCart = true;
      }
      const acceptedCoockies = localStorage.getItem('cookiesAccept');
      if (acceptedCoockies === null) {
        this.visibleCookies = false;

      } else {
          this.visibleCookies = true;

      }
      const mainBox = document.getElementById('cookiesBox');
      if (localStorage.getItem('pageLanguage') !== null) {
          this.showLang = localStorage.getItem('pageLanguage');
      } else {
          this.showLang = 'en';
      }
      // mainBox.classList.add(this.showLang);
  }

  expandInfo() {
    const box = document.getElementById('cookiesBox');
    const basic = document.getElementById('basicCookies');
    const more = document.getElementById('moreCookies');
    const close = document.getElementsByClassName('cookieClose');
    basic.classList.add('hide');
    box.classList.add('open');
    more.classList.remove('hide');
    close[0].classList.add('expaned');

  }

  acceptCookies() {
      localStorage.setItem('cookiesAccept', 'true');
      this.visibleCookies = true;
      this.subscriptionsService.setIsCookieSet(true);
  }
}
